import s from "./platformAdmin.module.css";

export const PRESET_CITIES = [
  "Москва",
  "Санкт-Петербург",
  "Новосибирск",
  "Екатеринбург",
  "Казань",
  "Нижний Новгород",
  "Краснодар",
  "Самара",
  "Ростов-на-Дону",
];

export const LEAD_FUNNEL_STAGES = [
  { id: "new", label: "Новые", hint: "Ещё не писали" },
  { id: "contacted", label: "Связались", hint: "Первое касание" },
  { id: "replied", label: "Ответили", hint: "Есть ответ" },
  { id: "demo", label: "Демо", hint: "Показали продукт" },
  { id: "trial", label: "Триал", hint: "Зарегистрировали клуб" },
  { id: "paid", label: "Оплатили", hint: "Платящий клиент" },
];

export const LEAD_BOARD_STAGES = [
  ...LEAD_FUNNEL_STAGES,
  { id: "lost", label: "Отказ", hint: "Не подошло" },
  { id: "do_not_contact", label: "Не беспокоить", hint: "Стоп-лист" },
];

export const LEAD_STAGE_COLORS = {
  new: "#7c3aed",
  contacted: "#2563eb",
  replied: "#0891b2",
  demo: "#0d9488",
  trial: "#ca8a04",
  paid: "#16a34a",
  lost: "#e11d48",
  do_not_contact: "#64748b",
};

function pctLabel(value) {
  if (value == null || Number.isNaN(value)) return "—";
  return `${value}%`;
}

export function mergeCityOptions(stats) {
  const fromDb = (stats?.top_cities || []).map((row) => row.city).filter(Boolean);
  const merged = [...PRESET_CITIES];
  for (const city of fromDb) {
    if (!merged.some((item) => item.toLowerCase() === city.toLowerCase())) {
      merged.push(city);
    }
  }
  return merged;
}

export function CityQuickPick({
  value,
  onChange,
  cities,
  label,
  allowAll = false,
  allLabel = "Все города",
  datalistId = "lead-city-suggestions",
}) {
  const normalized = String(value || "").trim();
  const presetMatch = cities.some(
    (city) => city.toLowerCase() === normalized.toLowerCase(),
  );
  const customValue = normalized && !presetMatch ? normalized : "";

  return (
    <div className={s.leadCityPick}>
      {label ? <span className={s.leadCityPickLabel}>{label}</span> : null}
      <div className={s.leadCityChips}>
        {allowAll ? (
          <button
            type="button"
            className={`${s.leadCityChip} ${!normalized ? s.leadCityChipActive : ""}`}
            onClick={() => onChange("")}
          >
            {allLabel}
          </button>
        ) : null}
        {cities.map((city) => (
          <button
            key={city}
            type="button"
            className={`${s.leadCityChip} ${
              normalized.toLowerCase() === city.toLowerCase() ? s.leadCityChipActive : ""
            }`}
            onClick={() => onChange(city)}
          >
            {city}
          </button>
        ))}
      </div>
      <div className={s.leadCityCustomRow}>
        <input
          className={s.clubSearch}
          value={customValue}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Другой город…"
          list={datalistId}
        />
        <datalist id={datalistId}>
          {cities.map((city) => (
            <option key={city} value={city} />
          ))}
        </datalist>
      </div>
    </div>
  );
}

export function LeadFunnel({ stats, activeStatus, onSelectStatus }) {
  const byStatus = stats?.by_status || {};
  const total = stats?.total || 0;
  const maxCount = Math.max(
    1,
    ...LEAD_FUNNEL_STAGES.map((stage) => byStatus[stage.id] || 0),
  );

  return (
    <section className={s.leadFunnelPanel}>
      <div className={s.leadFunnelHead}>
        <div>
          <h2 className={s.exportPanelTitle}>Воронка лидов</h2>
          <p className={s.exportPanelLead}>
            Нажмите на этап — отфильтруете список. Конверсия в оплату:{" "}
            <strong>{pctLabel(stats?.conversion?.overall_to_paid)}</strong>
          </p>
        </div>
        <button
          type="button"
          className={`${s.leadViewToggleBtn} ${!activeStatus ? s.leadViewToggleBtnActive : ""}`}
          onClick={() => onSelectStatus("")}
        >
          Все ({total})
        </button>
      </div>

      <div className={s.leadFunnelSteps}>
        {LEAD_FUNNEL_STAGES.map((stage, index) => {
          const count = byStatus[stage.id] || 0;
          const width = Math.max(6, Math.round((count / maxCount) * 100));
          const active = activeStatus === stage.id;
          const color = LEAD_STAGE_COLORS[stage.id];
          return (
            <button
              key={stage.id}
              type="button"
              className={`${s.leadFunnelStep} ${active ? s.leadFunnelStepActive : ""}`}
              onClick={() => onSelectStatus(stage.id)}
              title={stage.hint}
              style={{ "--stage-color": color }}
            >
              <div className={s.leadFunnelStepMeta}>
                <span className={s.leadFunnelStepLabel}>
                  {index + 1}. {stage.label}
                </span>
                <strong className={s.leadFunnelStepCount}>{count}</strong>
              </div>
              <div className={s.funnelTrack}>
                <div
                  className={s.funnelFill}
                  style={{ width: `${width}%`, background: color }}
                />
              </div>
              <span className={s.leadFunnelStepHint}>{stage.hint}</span>
            </button>
          );
        })}
      </div>

      {(stats?.conversion_steps || []).length ? (
        <div className={s.funnelConvGrid}>
          {stats.conversion_steps.map((step) => (
            <div key={step.id} className={s.funnelConvCard}>
              <span className={s.funnelConvLabel}>{step.label}</span>
              <strong className={s.funnelConvRate}>{pctLabel(step.rate)}</strong>
            </div>
          ))}
        </div>
      ) : null}

      <div className={s.funnelFooter}>
        <span>
          Отказ:{" "}
          <button
            type="button"
            className={s.leadFunnelFooterBtn}
            onClick={() => onSelectStatus("lost")}
          >
            <strong>{byStatus.lost || 0}</strong>
          </button>
        </span>
        <span>
          Не беспокоить:{" "}
          <button
            type="button"
            className={s.leadFunnelFooterBtn}
            onClick={() => onSelectStatus("do_not_contact")}
          >
            <strong>{byStatus.do_not_contact || 0}</strong>
          </button>
        </span>
      </div>
    </section>
  );
}

export function LeadSummaryCards({ stats, activeStatus, onSelectStatus }) {
  const byStatus = stats?.by_status || {};
  const cards = [
    { id: "", label: "Всего", value: stats?.total ?? 0 },
    { id: "new", label: "Новые", value: byStatus.new ?? 0 },
    { id: "contacted", label: "Связались", value: byStatus.contacted ?? 0 },
    { id: "trial", label: "Триал", value: byStatus.trial ?? 0 },
    {
      id: "paid",
      label: "Оплатили",
      value: byStatus.paid ?? 0,
      warn: true,
    },
  ];

  return (
    <div className={s.clubsSummaryGrid}>
      {cards.map((card) => (
        <button
          key={card.id || "all"}
          type="button"
          className={`${s.clubsSummaryCard} ${card.warn ? s.clubsSummaryWarn : ""} ${
            activeStatus === card.id ? s.leadSummaryCardActive : ""
          }`}
          onClick={() => onSelectStatus(card.id)}
        >
          <span>{card.label}</span>
          <strong>{card.value}</strong>
        </button>
      ))}
    </div>
  );
}

function LeadBoardCard({ lead, statusOptions, onUpdate, onDelete }) {
  const color = LEAD_STAGE_COLORS[lead.status] || "#64748b";

  return (
    <article className={s.leadBoardCard}>
      <div className={s.leadBoardCardHead}>
        <strong>{lead.name}</strong>
        {lead.sport_type ? <span className={s.leadBoardTag}>{lead.sport_type}</span> : null}
      </div>
      {lead.city ? <div className={s.leadBoardMeta}>{lead.city}</div> : null}
      {lead.phone ? (
        <div className={s.leadBoardMeta}>
          <a href={`tel:${lead.phone}`}>{lead.phone}</a>
        </div>
      ) : null}
      {lead.email ? (
        <div className={s.leadBoardMeta}>
          <a href={`mailto:${lead.email}`}>{lead.email}</a>
        </div>
      ) : null}
      <select
        className={s.leadBoardSelect}
        value={lead.status}
        style={{ borderColor: `${color}55` }}
        onChange={(e) => onUpdate(lead.id, { status: e.target.value })}
      >
        {statusOptions.map((opt) => (
          <option key={opt.id} value={opt.id}>
            {opt.label}
          </option>
        ))}
      </select>
      <textarea
        className={s.leadBoardNotes}
        defaultValue={lead.notes || ""}
        rows={2}
        placeholder="Заметка…"
        onBlur={(e) => {
          const next = e.target.value.trim();
          if (next !== (lead.notes || "")) {
            onUpdate(lead.id, { notes: next });
          }
        }}
      />
      <div className={s.leadBoardActions}>
        {lead.source_url ? (
          <a href={lead.source_url} target="_blank" rel="noreferrer">
            Карточка
          </a>
        ) : (
          <span>{lead.source}</span>
        )}
        <button type="button" className={s.leadBoardDelete} onClick={() => onDelete(lead.id)}>
          Удалить
        </button>
      </div>
    </article>
  );
}

export function LeadBoard({ leads, statusOptions, onUpdate, onDelete }) {
  const columns = LEAD_BOARD_STAGES.map((stage) => ({
    ...stage,
    items: leads.filter((lead) => lead.status === stage.id),
  }));

  return (
    <div className={s.leadBoard}>
      {columns.map((col) => (
        <div
          key={col.id}
          className={s.leadBoardCol}
          style={{ "--stage-color": LEAD_STAGE_COLORS[col.id] }}
        >
          <header className={s.leadBoardColHead}>
            <span>{col.label}</span>
            <strong>{col.items.length}</strong>
          </header>
          <div className={s.leadBoardColBody}>
            {col.items.length ? (
              col.items.map((lead) => (
                <LeadBoardCard
                  key={lead.id}
                  lead={lead}
                  statusOptions={statusOptions}
                  onUpdate={onUpdate}
                  onDelete={onDelete}
                />
              ))
            ) : (
              <div className={s.leadBoardEmpty}>Пусто</div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
